angular.module('manufacturing')
    .controller('ManufacturingOrderChangeStatusController', function ($scope, $rootScope, $uibModalInstance, ManufacturingOrder, ManufacturingOrderService, data) {
        this.$onInit = () => {
            this.statuses = ManufacturingOrderService.statuses()
            this.item = data
            this.form = {
                id: data.id,
                status: data.status
            }

            ManufacturingOrder.get({id: data.id}).$promise
                .then(item => {
                    this.order = angular.copy(item)
                    this.checkIfClientAcceptanceRequired()
                })
        }

        this.checkIfClientAcceptanceRequired = () => {
            let clientStatusShouldBeAccepted = !(this.order.client.status === 'ACTIVE' || this.order.clientStatusAcceptance?.status === this.order.client.status);
            this.clientStatusAcceptanceRequired = clientStatusShouldBeAccepted && this.form.status !== 'CANCELLED';
        }

        this.onClientStatusAcceptanceChanged = () => {
            if(this.form.clientStatusAcceptance.confirmation === true){
                this.form.clientStatusAcceptance.status = this.form.client.status
            }
            else {
                delete this.form.clientStatusAcceptance.status
            }
        }

        this.onStatusChanged = (status) => {
            this.form.status = status
            this.checkIfClientAcceptanceRequired()
        }

        this.save = () => {
            return ManufacturingOrder.changeStatus({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast('manufacturing-order.updated')
            })
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
